var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExpand = function SvgExpand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-24": 18,
    viewBox: "0 0 17.6 17.6",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.22 5.96a.75.75 0 0 0 1.28-.53V1.01a.75.75 0 0 0-.42-.93.8.8 0 0 0-.33-.08h-4.68a.75.75 0 1 0 0 1.5H15l-4.25 4.25a.75.75 0 0 0 0 1 .74.74 0 0 0 .51.24.74.74 0 0 0 .49-.24L16 2.592V5.43c0 .199.079.39.22.53M5.43 17.5H.75a.74.74 0 0 1-.53-.22.75.75 0 0 1-.22-.53v-4.68a.75.75 0 1 1 1.5 0v2.87l3.83-3.83a.75.75 0 0 1 1.06 1.06L2.56 16h2.87a.75.75 0 1 1 0 1.5",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExpand);
export default ForwardRef;